<template>
	<div class="send_http">
		<v-dialog
			v-model="dialog"
			transition="dialog-bottom-transition"
			fullscreen
			hide-overlay
			scrollable
		>
			<v-card tile>
				<v-card-text>
					<div class="modal_header">
						<div class="close" @click="close_cb">
							<Icon name="close"/>
						</div>
					</div>
					<div class="modal_body" :class="{ 'crmcalls-editor': data_render.card === 'send_crmcalls' }">
						<h2 class="modal_title" v-if="this.data_render.card=='robot'">Реплика робота</h2>

						<h2 class="modal_title" v-if="this.data_render.card=='answer'">Ответы клиента</h2>

            <h2 class="modal_title" v-if="this.data_render.card === 'send_sms' && this.data_render.message_channel !== 'email'">Отправить смс</h2>
            <h2 class="modal_title" v-if="this.data_render.card === 'send_sms' && this.data_render.message_channel === 'email' && !this.data_render.email_notification">Отправить email</h2>
            <h2 class="modal_title" v-if="this.data_render.card === 'send_sms' && this.data_render.email_notification">Email-уведомление</h2>
						<h2 class="modal_title" v-if="this.data_render.card=='send_http'">Отправить http запрос</h2>
						<h2 class="modal_title" v-if="this.data_render.card == 'send_crmcalls'">Отправить в CRMCalls CC</h2>
						<h2 class="modal_title" v-if="this.data_render.card=='send_tg'">Отправить сообщение в
							телеграм</h2>
						<h2 class="modal_title" v-if="this.data_render.card=='blacklist'">Черный список</h2>
						<h2 class="modal_title" v-if="this.data_render.card=='callcenter'">Перевод звонка</h2>
						<h2 class="modal_title" v-if="this.data_render.card=='target'">Цель</h2>

						<h2 class="modal_title" v-if="this.data_render.card=='forwarding'">Переадресация на блок</h2>
						<h2 class="modal_title" v-if="this.data_render.card=='amocrm'">Интеграция с amoCRM</h2>
						<h2 class="modal_title" v-if="this.data_render.card=='bitrix'">Интеграция с Bitrix24</h2>

						<div class="nick_name_block" v-if="showNickName">
							<h3>Псевдоним блока</h3>
                            <!-- <pre> это points наши стрелки {{ JSON.stringify(pointsExt) }}</pre>
                            <pre> это наш data_local {{ JSON.stringify(data_render) }}</pre> -->
							<v-text-field
									height="40"
									v-model="data_render.nickname"
									placeholder="Укажите псевдоним блока"
									hide-details="auto"
									:rules="[rules.validNick, rules.counter]"
							></v-text-field>
						</div>
						<RobotReplic v-if="this.data_render.card=='robot'" :data="data_render" :edit_callback="edit_callback" @valid="validEmit"/>
						<AnswerClient v-if="this.data_render.card=='answer'" :data="data_render" :edit_callback="edit_callback" @valid="validEmit"/>
            <EmailNotification
              v-if="
                this.data_render.card === 'send_sms' &&
                this.data_render.email_notification
              "
              :data="data_render"
              :edit_callback="edit_callback"
            />
            
            <SendEmail
              v-if="
                this.data_render.card === 'send_sms' &&
                this.data_render.message_channel === 'email' &&
                !this.data_render.email_notification
              "
              :data="data_render"
              :edit_callback="edit_callback"
              :sms-gate-integrations="smsGateIntegrations"
            />
          <SendSms
            v-if="this.data_render.card=='send_sms' && this.data_render.message_channel !== 'email'"
            :data="data_render"
            :edit_callback="edit_callback"
            :sms-gate-integrations="smsGateIntegrations"
            :has-sms-leads="hasSmsLeads"
            :sms-integrations-loaded="smsIntegrationsLoaded"
          />
						<SendHttp v-if="this.data_render.card=='send_http'" :data="data_render" :edit_callback="edit_callback"/>
						<SendCrmCalls v-if="this.data_render.card=='send_crmcalls'" :data="data_render" :edit_callback="edit_callback"/>
						<BlackList v-if="this.data_render.card=='blacklist'" :data="data_render" :edit_callback="edit_callback"/>
						<SendTelegram v-if="this.data_render.card=='send_tg'" :data="data_render" :edit_callback="edit_callback"/>
						<CallCenter v-if="this.data_render.card=='callcenter'" :data="data_render" :edit_callback="edit_callback"/>
						<TargetPoint v-if="this.data_render.card=='target'" :data="data_render" :edit_callback="edit_callback"/>
						<ForwardingBlock v-if="this.data_render.card=='forwarding'" :data="data_render" :allBlocks="allBlocksName" :edit_callback="edit_callback"/>
						<IntegrationAmoCRM v-if="this.data_render.card=='amocrm'" :data="data_render" :edit_callback="edit_callback"/>
						<IntegrationBitrix24 v-if="this.data_render.card=='bitrix'" :data="data_render" :edit_callback="edit_callback"/>

						<div class="button_container">
							<div class="redValid" v-if="this.data_render.card=='answer' && !validAnswerWords">Нельзя сохранить если в группах есть одинаковые слова!</div>
              <div class="redValid" v-if="this.data_render.card == 'send_http' && !validSendHTTP">Параметры запроса не корректны</div>
							<div class="save btn_save" :class="{ 'is-disabled': isSaveDisabled }" @click="save" >Сохранить</div>
							<div class="cancel_btn1">
                <div v-if="this.data_render.card=='answer' && this.data_render.type===0">
                  <v-tooltip top transition="fade-transition">
                    <template v-slot:activator="{on, attrs}">
                      <div v-bind="attrs" v-on="on">
                        <button class="btn1" :disabled="data_render.card!=='answer'" @click="exportAnswers()"><Icon name="downloaad" />Экспорт </button>
                      </div>
                    </template>
                    <span>Экспорт всех ответов блока</span>
                  </v-tooltip>
                </div>
                <div v-if="this.data_render.card=='answer' && this.data_render.type ===0">
                  <v-tooltip top transition="fade-transition">
                    <template v-slot:activator="{on, attrs}">
                      <div v-bind="attrs" v-on="on">
                        <button class="btn2" @click="openImport"><Icon name="upload"/>Импорт</button>
                      </div>
                    </template>
                    <span>Импорт всех ответов блока с полной заменой</span>
                  </v-tooltip>
                </div>
						</div>
						<div class="cancel_btn" @click="close_cb">Отменить</div>
						</div>
					</div>
					<transition name="fade">
            <div v-if="isImport" class="import-layer" @click.self="isImport = false">
              <transition name="scale">
                <div class="import-modal" :class="{ 'is-result': importStep === 'result' }" role="dialog" aria-modal="true">
                  <div class="import_header">
                    <h3 class="import_title">Импорт ключевых слов</h3>
					<button class="import_close" aria-label="Закрыть" @click="isImport = false">
						<Icon name="close"/>
					</button>
                  </div>
                  <div class="import_content" :class="importStep">
					<template v-if="importStep === 'drop'">
                      <ImportDropzone
                        accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        @parsed="onImportParsed"
                      />
                      <div class="import_actions">
                        <button class="btnInDropZone" :disabled="!canImport" @click="toConfirm">Импорт</button>
                      </div>
                    </template>
                    
                    <template v-else-if="importStep === 'confirm'">
                      <div class="confirm-box">
                        <div class="confirm-icon"><Icon name="info"/></div>
                        <p class="confirm-text">
                          Все текущие ответы блока будут удалены и заменены ответами из импортируемого файла
                          без возможности восстановления.
                        </p>
                        <div class="import_actions">
                          <button class="btnInDropZone" @click="applyImportConfirmed">Импорт</button>
                        </div>
                        <div class="center-actions">
                          <button class="linkLike" @click="isImport = false">Закрыть</button>
                        </div>
                      </div>
                    </template>
                    
                    <template v-else-if="importStep === 'result'">
                      <div class="success-banner">
                        <Icon name="ok"/>
                        <div class="banner-content">
                          <div class="banner-title">Успешно загружено:</div>
                          <div class="banner-value">
                            <b>{{ importStats.groups }}</b> ответов, <b>{{ importStats.keywords }}</b> ключевых слов
                          </div>
                        </div>
                      </div>
                      <div class="import_actions">
                        <button class="btn1" @click="finishImport">Завершить</button>
                      </div>
                    </template>
                  </div>
                </div>
              </transition>
            </div>
          </transition>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>
<script>
import Icon from '../../SetIcon.vue'
import RobotReplic from './Editors/RobotReplic.vue'
import AnswerClient from './Editors/AnswerClient.vue'
import SendSms from './Editors/SendSms.vue'
import SendEmail from './Editors/SendEmail.vue'
import EmailNotification from './Editors/EmailNotification.vue'
import SendTelegram from './Editors/SendTelegram.vue'
import SendHttp from './Editors/SendHttp.vue'
import SendCrmCalls from './Editors/SendCrmCalls.vue'
import CallCenter from './Editors/CallCenter.vue'
import TargetPoint from './Editors/TargetPoint.vue'
import ForwardingBlock from './Editors/Forwarding.vue'
import BlackList from './Editors/BlackList.vue'
import IntegrationAmoCRM from "@/components/Modal/Scenaries/Editors/IntegrationAmoCRM";
import IntegrationBitrix24 from "@/components/Modal/Scenaries/Editors/IntegrationBitrix24";
import ImportDropzone from '@/components/Table/ImportDropzone.vue'

export default {
	props: ['show_dialog', 'close', 'data'],
	components: {
		Icon,
		ImportDropzone,
		RobotReplic,
		AnswerClient,
		SendSms,
    SendEmail,
		SendHttp,
    SendCrmCalls,
		SendTelegram,
		BlackList,
		CallCenter,
		TargetPoint,
		ForwardingBlock,
		IntegrationAmoCRM,
		IntegrationBitrix24,
    EmailNotification
	},
	watch: {
		show_dialog: function (val) {
			this.dialog = val
			let local_data=JSON.parse(JSON.stringify(this.data))
			this.data_save = local_data
			this.data_render = local_data
      if (this.data_render.card === 'send_sms' && !this.data_render.email_notification) {
        this.loadSmsIntegrations()
      }

			this.allBlocksName = window.id_all_blocks(this.data_render)

			if (!val) {
				window.stop_edit()
			} else {
				window.start_edit()
			}

		},
	},
	methods: {
		finishImport() {
    this.isImport = false
    this.importStep = 'drop'
  },
		toConfirm() {
    if (!this.parsedImport?.length) return
    this.importStep = 'confirm'
  },
	openImport() {
        this.isImport = true
        this.importStep = 'drop'
        this.parsedImport = null
        this.importStats = { groups: 0, keywords: 0 }
        this.importHasDuplicates = false
  },
		onImportParsed(payload) {
          let rows = []

        if (payload && Array.isArray(payload.rows)) rows = payload.rows
        else if (payload && Array.isArray(payload.data)) rows = payload.data
        else if (Array.isArray(payload)) rows = payload
        else if (payload && Array.isArray(payload.result)) rows = payload.result

        rows = rows.map(r => {
          if (Array.isArray(r)) return r
          if (r && typeof r === 'object') {
            const g = r.group || r.Группа || r.title || r.name || r.word
            const w = r.word || r['Ключевое слово'] || r.text
            return [g, w]
          }
          return [null, null]
        }).filter(([g, w]) => g && w)
      
        this.parsedImport = rows.length ? rows : null
		this.importStep = 'drop'
},

applyImportConfirmed() {
  if (!this.parsedImport?.length) return

  const norm  = v => String(v ?? '').trim()
  const keyOf = v => norm(v).toLowerCase()

  const map = new Map() 
  const displayNameByKey = new Map()

  for (const [gRaw, wRaw] of this.parsedImport) {
    const k = keyOf(gRaw)
    const w = norm(wRaw)
    if (!k || !w) continue
    if (!map.has(k)) {
      map.set(k, new Set())
      displayNameByKey.set(k, norm(gRaw))
    }
    map.get(k).add(w)
  }

  const stats = {
    groups: map.size,
    keywords: Array.from(map.values()).reduce((sum, set) => sum + set.size, 0),
  }

  let newBox = []
  for (const [k, set] of map) {
    newBox.push({
      word: displayNameByKey.get(k) || k,
      items: Array.from(set).map(text => ({ text })),
    })
  }

  const oldBox = Array.isArray(this.data_render.box) ? this.data_render.box : []
  const systemGroups = oldBox.filter(g => g && g.items === 'system')

  const importedNames = new Set(newBox.map(g => keyOf(g.word)))
  const keepSystems = systemGroups.filter(g => !importedNames.has(keyOf(g.word)))

  keepSystems.sort((a, b) => {
    const order = { 'нет': 0, 'да': 1 }
    const aw = order[keyOf(a.word)]
    const bw = order[keyOf(b.word)]
    return (aw ?? 99) - (bw ?? 99)
  })

  newBox = [...keepSystems, ...newBox]

  this.data_render.box = newBox
  this.data_save.box = newBox
  this.edit_callback && this.edit_callback(this.data_render)

  const words = []
  for (const g of newBox) {
    if (!Array.isArray(g.items)) continue
    for (const it of g.items) {
      const t = keyOf(it?.text)
      if (t) words.push(t)
    }
  }
  const unique = new Set(words)
  this.validAnswerWords = unique.size === words.length
  this.importHasDuplicates = !this.validAnswerWords

  this.importStats = stats
  this.importStep = 'result'

  try {
 {
    const host = this.$parent
    const graph = JSON.parse(host?.data?.data || '{}')
    const nodeId = this.data_render?.id || this.data?.id
    const node = nodeId ? graph[nodeId] : false

    if (node) {
      const oldPoints = Array.isArray(node.points) ? node.points : []
      const hadTail = oldPoints.length && oldPoints[oldPoints.length - 1] === false

      const base = new Array(this.data_render.box.length).fill(null)
      node.points = hadTail ? base.concat(false) : base

      host.data.data = JSON.stringify(graph)
    }
  }
} catch (e) {
  console.log('reset points on import error:', e)
}
},

async exportAnswers() {
  if (!this.data_render || this.data_render.card !== 'answer') {
    alert('Открой блок "Ответы клиента", чтобы выполнить экспорт.')
    return
  }
  const rows = []
  const box = Array.isArray(this.data_render.box) ? this.data_render.box : []
  box.forEach(g => {
    if (Array.isArray(g.items)) {
      g.items.forEach(it => rows.push([String(g.word||'').trim(), String(it?.text||'').trim()]))
    }
  })

  const { default: ExcelJS } = await import('exceljs')
  const wb = new ExcelJS.Workbook()
  const ws = wb.addWorksheet('Answers')

  ws.addRow(['Группа', 'Ключевое слово'])
  rows.forEach(r => ws.addRow(r))

  const fileNameSafe = String(this.data_render.nickname || 'answers')
    .replace(/[^\w-]+/g, '_').replace(/_+/g, '_').replace(/^_+|_+$/g, '')

  const buffer = await wb.xlsx.writeBuffer()
  const blob = new Blob([buffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = `answers_${fileNameSafe || 'answers'}.xlsx`
  document.body.appendChild(a); a.click(); a.remove()
  URL.revokeObjectURL(url)
},
loadSmsIntegrations() {
  this.smsIntegrationsLoaded = false

  this.$http.get('integrations/sms_services_status')
    .then((response) => {
      const data = response.data || response

      this.hasSmsLeads = !!data.smsleads
      this.smsGateIntegrations = Array.isArray(data.smsgate) ? data.smsgate : []
    })
    .catch(() => {
      this.hasSmsLeads = false
      this.smsGateIntegrations = []
    })
    .finally(() => {
      this.smsIntegrationsLoaded = true
    })
},
// Дальше старый код !!!
		validEmit(obj){
			this.validForm = obj
		},

		save() {
      if (this.data_save && this.data_save.typeRequest !== 'POST') {
        delete this.data_save.params;
        delete this.data_save.postURL;
      }
      if (this.isSaveDisabled) return
			let _this = this
			function saveFun(){
				if (_this.data_save) {
					window.data_save(_this.data_save)
					_this.close_cb()
				}
			}

			if (this.validForm && this.rules.validNick(this.data_render.nickname) === true && this.rules.counter(this.data_render.nickname) === true) {
				if (this.data_render.card === 'robot') {
					if (this.data_render.type === 0) {
						if (this.validForm.aria) saveFun()
					} else if (this.data_render.type === 1) {
						if (this.validForm.file_play) saveFun()
					} else if (this.data_render.type === 2) {
						if (this.validForm.isRecord) saveFun()
					}
				} else if (this.data_render.card === 'answer') {
					let arrAllWords = []

					for(let key in this.data_render.box){
						if(Array.isArray(this.data_render.box[key].items)) arrAllWords = [...arrAllWords, ...this.data_render.box[key].items]
					}
					arrAllWords = arrAllWords.map((item) => item.text)
					if(new Set(arrAllWords).size === arrAllWords.length) {
						this.validAnswerWords = true
						saveFun()
					} else {
						this.validAnswerWords = false
					}
				} else {
					saveFun()
				}
			}
		},
		edit_callback(data) {
			// console.log('🚀 -> edit_callback -> data:', data)
      if(data && data.typeRequest && data.typeRequest === 'POST'){
        // this.data.validSendHTTP = 
        try{
          let params = data.params.replaceAll('\n', '').replaceAll(' ', '').replaceAll('\t', '')
          JSON.parse(params)
          this.validSendHTTP = true
        }
        catch(err){
          this.validSendHTTP = false
        }
      }
			this.data_render = data
			this.data_save = data
      
		},
		close_cb() {
			this.isImport = false
			this.dialog = false
			this.data_save = false
			this.data_render = false
			this.dialog = false
			this.close()
			this.nickname = ''
			this.validForm = true
		},
	},
	computed: {
    pointsExt() {
    try {
      const graph = JSON.parse(this.$parent.data?.data || '{}')   // весь сценарий (строка → объект)
      const id = this.data_render?.id || this.data?.id            // id текущего блока
      return (id && graph[id]?.points) ? graph[id].points : []
    } catch (e) {
      return []
    }
  },
  isSaveDisabled() {
    if (
      this.data_render.card === 'send_sms' &&
      this.data_render.email_notification
    ) {
      const recipientMissing =
        !String(this.data_render.recipient_email || '').trim()
  
      return recipientMissing
    }
  
    if (
      this.data_render.card === 'send_sms' &&
      this.data_render.message_channel === 'email'
    ) {
      const senderMissing =
        !String(this.data_render.sender_name || '').trim()
  
      const customRecipientMissing =
        this.data_render.recipient_type === 'custom' &&
        !String(this.data_render.recipient_email || '').trim()
  
      return senderMissing || customRecipientMissing
    }
  
    return false
  },
		showNickName() {
			return this.data_render.card !== 'target' && this.data_render.card !== 'blacklist' // && this.data_render.card !== 'answer'
		},
		nickNameBlock(){
			return Object.values(this.allBlocksName)
		},
		canImport() {
   return Array.isArray(this.parsedImport) && this.parsedImport.length > 0
}
	},
	data() {
		return {
			importStep: 'drop',
            importStats: { groups: 0, keywords: 0 },
            importHasDuplicates: false,
			uploadedText: '',
			parsedImport: null,
			isImport: false,
			importMode: 'replace',
			dialog: false,
			data_save: {},
			data_render: {},
			nickname: '',
			allBlocksName: [],
      smsGateIntegrations: [],
      hasSmsLeads: false,
      smsIntegrationsLoaded: false,
			rules: {
				validNick: value => !(this.nickNameBlock.findIndex( nick => nick === value) > -1) || 'Такой псевдоним уже используется',
				counter: value => value === undefined ? true : (value.length <= 12) || 'Максимальная длинна псевдонима 12 символов'
			},
			validForm: true,
			validAnswerWords: true,
      validSendHTTP: true
		}
	},
}
</script>
<style scoped>
.cancel_btn{
  color: #4B5EFF;
}
.import-modal.is-result{
  width: 420px;
  height: 320px;
}
.success-banner .banner-content{
  display: grid;
  gap: 4px;
  justify-items: start;
  text-align: left;
}
.success-banner .banner-title,
.success-banner .banner-value{
  margin: 0;
  padding: 0;
  text-indent: 0;
}
.import_content.drop .btnInDropZone{
  width: 440px;
  height: 48px;
  padding: 0 22px;
  border-radius: 12px;
  font-size: 16px;
  color: #fff;
}
.import_content.drop{
display:grid; grid-template-columns:max-content; justify-content:center;
}
.import_content.drop > .import_actions{
  width:100%; justify-self:stretch;
}

.import_content.confirm .import_actions{
  margin-top:35px;
}
.import_content.result{
  flex:1;
  display:grid;
  grid-template-columns:1fr;
  place-items:center;
  position:relative;
  padding-bottom:72px;
}
.import_content.result .import_actions{
  position:absolute;
  left:24px; right:24px; bottom:20px;
  display:flex; justify-content:center;
  margin:0;
}
.import_content.result .success-banner{
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 12px;
  padding: 16px 20px;
  border-radius: 8px;
}
.import_content.result .banner-title{ font-size: 18px; font-weight: 700; }
.import_content.result .banner-value{ font-size: 16px; line-height: 1.4; }
.import_content.result .success-banner b{ font-weight: 800; }
.import_content.result .success-banner,
.import_content.result .alert-banner{ justify-self:stretch; width:100%; }
.import-modal { display: flex; flex-direction: column; }
.import_content{flex:1; }
.import_content .success-banner,
.import_content .alert-banner { width: 100%; }
.import_content .import_actions { margin-top: 15px; }

.confirm-box .import_actions { width: 100%; justify-self: stretch; }
.btn1,
.btn2,
.btnInDropZone,
.save.btn_save {
  transition: filter .2s ease, transform .08s ease, box-shadow .2s ease;
  cursor: pointer; color: #fff;
}

.btn1:hover,
.btn2:hover,
.btnInDropZone:hover,
.save.btn_save:hover {
  filter: brightness(0.95);
}

.btn1:active,
.btn2:active,
.btnInDropZone:active,
.save.btn_save:active {
  filter: brightness(0.9);
  transform: translateY(1px);
}

.btn1:focus-visible,
.btn2:focus-visible,
.btnInDropZone:focus-visible,
.save.btn_save:focus-visible {
  outline: 2px solid #2B2D33;
  outline-offset: 2px;
}

.save.btn_save.is-disabled {
  pointer-events: none;
  opacity: .6;
  filter: none;
  transform: none;
}
.success-banner{
  display:flex; align-items:flex-start;
  background:#CFF5D2; border-radius:4px;
  padding:12px 16px; color:#1F3C44;
}
.alert-banner{
  display:flex; align-items:flex-start;
  background:#F8B8B8; border-radius:4px;
  padding:12px 16px; color:#1F3C44;
}
.banner-content{ display:grid; gap:4px; }
.banner-title{ font-weight:700; line-height:1.2; }
.banner-value{ line-height:1.2; }
.confirm-box{
  background:#fff;
  border-radius:12px;
  padding:20px;
  display:grid;
  justify-items:center;
  gap:14px;
  text-align:center;
}
.confirm-icon{ width:44px; height:44px; display:grid; place-items:center; }
.confirm-text{
  color:#2B2D33;
  font-size:16px;
  line-height:1.35;
  margin: 0 6px 6px;
}
.center-actions{ display:flex; justify-content:center; }
.linkLike{
  background:transparent; border:0; color:#4B5EFF; cursor:pointer;
  padding:10px 0; font-weight:600;
}
.infoemodzi{
  display: flex;
  align-items: center;
}
.info-icon {
  position: relative;
  top: -4px;
  cursor: pointer;
}
.v-tooltip__content {
  max-width: 250px;
  white-space: normal;
  word-wrap: break-word;
}
.dialog-root { position: relative; }

.import-layer{
  position: fixed;
  inset: 0;
  background: rgba(78, 78, 78, 0.55);
  display: grid;
  place-items: center; 
  z-index: 5; 
}

.import-modal{
  width: 496px;
  height: 398px;
  max-width: calc(100vw - 48px);
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 12px 40px rgba(0,0,0,.25);
  overflow: hidden;
}

.import_header{
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 18px 20px 6px;
}

.import_title{
  grid-column: 2;
  justify-self: center;
  margin: 0;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.25;
  text-align: center;
}

.import_close{
  grid-column: 3;
  justify-self: end; 
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 0;
  background: transparent;
  cursor: pointer;
}
.close{ cursor:pointer; }

.import_content{ padding: 4px 24px 20px; }

.dropzone{
  border: 2px dashed #C9D6DF;
  background: #F7FBFF;
  border-radius: 8px;
  padding: 20px;
  margin: 12px 0 20px;
}
.dz-inner{ display:grid; place-items:center; gap:8px; color:#4A4F55; }

.import_actions{
  display:flex; justify-content:center; gap:12px; margin-top: 8px;
}
.btn1{
  padding: 10px 20px; background: #4B5EFF; border: 1px solid #4B5EFF;
  border-radius: 8px; font-weight: 700; cursor: not-allowed;
}
.btn2{
  padding: 10px 20px; background: #fff; border: 1px solid #4B5EFF;
  border-radius: 8px; font-weight: 700; cursor: pointer;
}

.fade-enter-active, .fade-leave-active { transition: opacity .18s ease; }
.fade-enter, .fade-leave-to { opacity: 0; }
.scale-enter-active, .scale-leave-active { transition: transform .18s ease, opacity .18s ease; }
.scale-enter, .scale-leave-to { transform: scale(.98); opacity: 0; }
.cancel_btn1{
	display: grid;
	grid-auto-flow: column;
	justify-content: center;
	gap: 70px;
}
.btn1{
  padding: 10px 20px;
  background: #fff;
  border: 1px solid #4B5EFF; 
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  color: #2B2D33;
}

.btnInDropZone{
  display: block;
  width: 100%;
  text-align: center;
  padding: 14px 24px;
  font-size: 15px;
  font-weight: 800;
  background: #4B5EFF;
  border: 1px solid #4B5EFF; 
  border-radius: 10px;
  color: #eee;
  cursor: pointer;
}


.btn2{
   padding: 10px 20px;
  background: #fff;
  border: 1px solid #4B5EFF;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px; 
  font-weight: 600;
  font-size: 15px;
  color: #2B2D33;
  cursor: pointer;
  transition: all 0.2s ease;
}
.redValid {
	color: #DE4040;
}
.btn_unlock {
	font-style: normal;
	font-weight: 500;
	text-align: left;
	cursor: pointer;
	margin-bottom: 19px;
	font-size: 15px;
	line-height: 120%;
	color: #4B5EFF;
}

.form {
	display: inline-block;
	max-width: 600px;
}

.play {
	font-style: normal;
	font-weight: 500;
	font-size: 17px;
	line-height: 120%;
	color: #4B5EFF;
}

.btn_play {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	margin: 12px 0 0 0 !important;
	cursor: pointer;
}

.btn_play .icon {
	margin-right: 4px;
}

.my_input {
	font-style: normal;
	font-weight: 500;
	font-size: 15px;
	line-height: 120%;
	color: #808185;
	position: relative;
}

.my_input .icon {
	position: absolute;
	right: 7px;
	top: 17px;
}

.subtitle {
	font-style: normal;
	font-weight: 600;
	font-size: 15px;
	line-height: 120%;
	color: #404247;
	text-align: left;
	margin-bottom: 6px;
}

.modal_header {
	display: flex;
	align-self: flex-end;
}

.item_tab {
	margin: 32px auto 0 auto;
	max-width: 600px;
}

.modal_body {
	display: flex;
	justify-content: center;
	flex-direction: column;
	width: 100%;
}

.form_container {
	text-align: center;
	width: 100%;
}

.button_container {
	display: block;
	width: 100%;
}

.saveMyButton{
	display:flex;
}

.save {
	padding: 10px 20px 12px;
	background: #4B5EFF;
	border-radius: 8px;
	margin: 16px 0 0 0;
	max-width: 600px;
	display: inline-block;
	margin-bottom: 19px;
  width: auto;
}

.paste {
	padding: 9px 20px 10px;
	background: #FFFFFF;
	border: 1px solid #4B5EFF;
	border-radius: 8px;
	margin: 0;
	cursor: pointer;
	max-width: 235px;
	font-style: normal;
	font-weight: 600;
	font-size: 15px;
	line-height: 110%;
	color: #2B2D33;
}

.modal_title {
	margin-top: 32px;
	margin-bottom: 32px;
}

h3 {
	margin-bottom: 12px;
	text-align: left;
}

.close {
	margin-right: 52px;
	margin-top: 20px;
}

.nick_name_block {
	max-width: 600px;
	margin: 0 auto 30px auto;
	width: 600px;
}

.crmcalls-editor .nick_name_block {
  width: 690px;
  max-width: 100%;
  box-sizing: border-box;
}

@media (max-width: 600px) {
	.modal_body {
		padding: 15px;
	}

	.nick_name_block {
		width: 100%;
	}
}
</style>
